export const ITEMS_PER_PAGE = 100;

export const DEFAULT_SORT_COLUMN = "share";
export const DEFAULT_SORT_ORDER = "descend";
export const DEFAULT_TIME_GRANULARITY = "Monthly";

export const DEFAULT_RADIO_FILTERS = {
    isAll: true,
    isNew: false,
    isTrending: false,
};

export const TABLE_CONFIG = {
    LOADER_ROW_COUNT: 10,
    EXPAND_ICON_COLUMN_INDEX: 3,
} as const;

export const FILTER_PATTERNS = {
    FOLDER_CONTAINS: /Folder;contains;"([^"]*)"/,
} as const;
